import { EndpointReponseProps } from "../types";
// const baseURL = "http://localhost:8080/api";
// const baseURL = `${process.env.REACT_APP_BASE_URL_DEV}/api`;
const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;
export const Endpoints = {
  GetTeacherLogin: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/auth/login`,
      method: "POST",
    };
  },
  GetRequestOTP: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/auth/login/otp/send`,
      method: "POST",
    };
  },
  GetVerifyOTP: (token: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/auth/login/otp/validate/${token}`,
      method: "POST",
    };
  },
  GetValidateOnboardingToken: (token: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/auth/onboard/${token}`,
      method: "GET",
    };
  },
  GetCompleteOnboarding: (token: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/auth/onboard/${token}`,
      method: "POST",
    };
  },
  GetRequestPasswordReset: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/auth/request-reset`,
      method: "POST",
    };
  },
  GetTeacherProfile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/auth/profile`,
      method: "GET",
    };
  },

  GetCalendar: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/calendar`,
      method: "GET",
    };
  },

  GetSingleStudentProfile: (studentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/student/profile/${studentID}`,
      method: "GET",
    };
  },
  GetPlans: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/plans/filter?page=${page}&limit=${limit}`,
      method: "POST",
    };
  },

  GetSinglePlanDetails: (planID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/plan/${planID}`,
      method: "GET",
    };
  },

  GetCourses: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/courses/get?page=${page}&limit=${limit}`,
      method: "POST",
    };
  },

  GetSingleCourseDetails: (courseID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/course/${courseID}`,
      method: "GET",
    };
  },
  GetCourseLessons: (
    courseID: string,
    page: number,
    limit: number
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/lessons/${courseID}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetSingleLessonAssessments: (
    lessonID: string,
    page: number,
    limit: number
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/assessment/get/all/${lessonID}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetSingleAssessment: (assessmentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/assessment/${assessmentID}`,
      method: "GET",
    };
  },
  GetCreateAssessment: (lessonID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/assessment/create/${lessonID}`,
      method: "POST",
    };
  },
  GetAddAssessmentQuestion: (assessmentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/assessment/question/${assessmentID}`,
      method: "PATCH",
    };
  },
  GetUpdateAssessmentQuestion: (
    assessmentID: string,
    questionID: string
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/assessment/question/${assessmentID}/${questionID}`,
      method: "PATCH",
    };
  },
  GetDeleteAssessmentQuestion: (
    assessmentID: string,
    questionID: string
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/assessment/question/${assessmentID}/${questionID}`,
      method: "DELETE",
    };
  },
  GetToggleAssessmentStatus: (assessmentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/assessment/toggle-status/${assessmentID}`,
      method: "PATCH",
    };
  },

  GetSingleLesson: (lessonID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/lesson/${lessonID}`,
      method: "GET",
    };
  },
  GetStartLesson: (lessonID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/lesson/start/${lessonID}`,
      method: "GET",
    };
  },
  GetCreateRecording: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/course/recording/create`,
      method: "POST",
    };
  },
  GetRecordingsUnderCourse: (
    courseID: string,
    page: number,
    limit: number
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/course/recordings/${courseID}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetLessonMaterials: (
    lessonID: string,
    page: number,
    limit: number
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/materials/${lessonID}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetCreateMaterial: (lessonID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/material/create/${lessonID}`,
      method: "POST",
    };
  },
  GetSingleMaterial: (materialID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/material/${materialID}`,
      method: "GET",
    };
  },
  GetDeleteMaterial: (materialID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/material/${materialID}`,
      method: "DELETE",
    };
  },
  GeteStudentsInCourse: (
    courseID: string,
    page: number,
    limit: number
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/student/course/${courseID}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetStudentAssessmentHistory: (studentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/student/assessments/${studentID}`,
      method: "GET",
    };
  },

  GetStudentPerformanceInCourse: (
    courseID: string,
    studentID: string
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/student/performance/${courseID}/${studentID}`,
      method: "GET",
    };
  },
  GetConversations: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/conversations`,
      method: "GET",
    };
  },
  GetConversationWithStudent: (studentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/teacher/conversation/${studentID}`,
      method: "GET",
    };
  },

  GetUploadFile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/file/s3/upload`,
      // route: `${baseURL}/file/upload`,
      method: "POST",
    };
  },
  GetUploadLargeFile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/file/s3/upload-large`,
      // route: `${baseURL}/file/upload-large`,
      method: "POST",
    };
  },
};
